/* eslint-disable @typescript-eslint/no-explicit-any */
import { WorkSchedule } from '@viterbit/web-app/dataAccess/model/WorkSchedule.model'
import { workScheduleListPaginated } from '@viterbit/web-app/dataAccess/service/workScheduledService'
import { GroupBase } from 'react-select'
import {
    FormSelectAsyncPaginate,
    FormSelectAsyncPaginateProps,
} from 'ui/src/components/Form'
import { FormBaseProps } from 'ui/src/components/Form/shared'

import { useNotification } from '../feedback/useNotification'


type FormSelectWorkScheduleProps<IsMulti extends boolean> = FormBaseProps &
    Omit<
        FormSelectAsyncPaginateProps<
            WorkSchedule,
            IsMulti,
            GroupBase<WorkSchedule>,
            { page: number }
        >,
        'loadOptions'
    >

type LoadOptions = FormSelectAsyncPaginateProps<
    WorkSchedule,
    boolean,
    GroupBase<WorkSchedule>,
    { page: number }
>['loadOptions']

const FormSelectWorkSchedule = <IsMulti extends boolean>({
    name,
    control,
    cacheOptions = true,
    isSearchable = false,
    ...rest
}: FormSelectWorkScheduleProps<IsMulti>) => {
    const notification = useNotification()
    const loadOptions: LoadOptions = async (search, loadedOptions, _meta) =>
        workScheduleListPaginated({ page: String(_meta?.page) })
            .then(({ data, meta }) => {
                const hasMore =
                    !!meta?.total &&
                    meta.page <
                        Math.ceil(meta.total / ((meta as any).pageSize ?? 10))
                return {
                    options: data,
                    hasMore,
                    additional: {
                        page: meta.page + 1,
                    },
                } as any
            })
            .catch((err) => {
                notification.push(
                    'danger',
                    'Fetching error',
                    err.errorCode ?? 'Error at fetch work schedule list'
                )
                return {
                    options: [],
                    hasMore: false,
                }
            })
    return (
        <>
            <FormSelectAsyncPaginate
                name={name}
                control={control}
                cacheOptions={cacheOptions}
                loadOptions={loadOptions}
                isSearchable={isSearchable}
                getOptionLabel={(x) => x.name}
                getOptionValue={(x) => x.id}
                loadOptionsOnMenuOpen
                additional={{
                    page: 1,
                }}
                {...rest}
            />
        </>
    )
}

export default FormSelectWorkSchedule
